import prize from './prize'
import prizeType from './prizeType'
import activityType from './activityType'
import activitiesSet from './activitiesSet'
import activitiesPrizeClaim from './activitiesPrizeClaim'

export default {
  ...prize,
  ...prizeType,
  ...activityType,
  ...activitiesSet,
  ...activitiesPrizeClaim
}
